// import * as AntdIcons from '@ant-design/icons';
// import {
//   AppstoreOutlined,
//   AreaChartOutlined,
//   ArrowsAltOutlined,
//   ContainerOutlined,
//   DesktopOutlined, EditOutlined,
//   HourglassFilled,
//   HourglassOutlined, LockOutlined,
//   MailOutlined,
//   MenuFoldOutlined,
//   MenuUnfoldOutlined,
//   PieChartOutlined,
//   UserAddOutlined,
//   UserOutlined,
// } from '@ant-design/icons';

import React from 'react';
import * as AntdIcons from '@ant-design/icons';

// @ts-ignore
export const getIcon = (name) => {
  if (!name) return null;

  // @ts-ignore
  const IconComponent = AntdIcons[name];

  if (IconComponent) {
    return React.createElement(IconComponent);
  }

  console.warn(`Icon "${name}" not found`);
  return null;
};
